<template>
  <div class="mp-card p-6">
    <div
      class="header is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center mb-4"
    >
      <p class="has-text-weight-bold m-0">
        {{ productIndex + 1 }}.
        {{ $t("mp:new_application.sections.items.item.title") }}
      </p>
      <div @click="removeProduct" class="trash">
        <b-icon icon-pack="fas" icon="trash-alt" type="is-grey-icon" />
      </div>
    </div>
    <form>
      <validation-observer ref="observer">
        <div class="columns">
          <div class="column">
            <BInputWithValidation
              v-model="name"
              :label="$t('mp:new_application.field.item.name')"
              label-position="on-border"
              rules="required"
            />
          </div>
          <div class="column">
            <BInputWithValidation
              v-model="externalId"
              :label="$t('mp:new_application.field.item.external_id')"
              label-position="on-border"
              rules="required"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <BInputWithValidation
              v-model.number="price"
              :lazy="true"
              :label="$t('mp:new_application.field.item.price')"
              label-position="on-border"
              rules="required|numeric"
            />
          </div>
          <div class="column">
            <BInputWithValidation
              v-model.number="quantity"
              :lazy="true"
              :label="$t('mp:new_application.field.item.quantity')"
              label-position="on-border"
              rules="required|numeric"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <BInputWithValidation
              v-model="description"
              :label="$t('mp:new_application.field.item.description')"
              label-position="on-border"
              rules="required"
            />
          </div>
        </div>
      </validation-observer>
    </form>
  </div>
</template>
<script>
import BInputWithValidation from "../input/BInputWithValidation.vue";

export default {
  props: {
    productIndex: {
      type: Number,
      required: true,
    },
  },
  components: { BInputWithValidation },
  computed: {
    name: {
      get() {
        return this.$store.getters["bnplInStoreApplication/getProduct"](
          this.productIndex
        ).name;
      },
      set(value) {
        this.$store.commit("bnplInStoreApplication/updateProduct", {
          index: this.productIndex,
          key: "name",
          value: value,
        });
      },
    },
    externalId: {
      get() {
        return this.$store.getters["bnplInStoreApplication/getProduct"](
          this.productIndex
        ).externalId;
      },
      set(value) {
        this.$store.commit("bnplInStoreApplication/updateProduct", {
          index: this.productIndex,
          key: "externalId",
          value: value,
        });
      },
    },
    price: {
      get() {
        return this.$store.getters["bnplInStoreApplication/getProduct"](
          this.productIndex
        ).price;
      },
      set(value) {
        this.$store.commit("bnplInStoreApplication/updateProduct", {
          index: this.productIndex,
          key: "price",
          value: value,
        });
      },
    },
    quantity: {
      get() {
        return this.$store.getters["bnplInStoreApplication/getProduct"](
          this.productIndex
        ).quantity;
      },
      set(value) {
        this.$store.commit("bnplInStoreApplication/updateProduct", {
          index: this.productIndex,
          key: "quantity",
          value: value,
        });
      },
    },
    description: {
      get() {
        return this.$store.getters["bnplInStoreApplication/getProduct"](
          this.productIndex
        ).description;
      },
      set(value) {
        this.$store.commit("bnplInStoreApplication/updateProduct", {
          index: this.productIndex,
          key: "description",
          value: value,
        });
      },
    },
    product() {
      return this.$store.getters["bnplInStoreApplication/getProduct"](
        this.productIndex
      );
    },
  },
  watch: {
    price: {
      handler() {
        this.$store.dispatch("calculation/calculate");
      },
    },
    quantity: {
      handler() {
        this.$store.dispatch("calculation/calculate");
      },
    },
  },
  methods: {
    removeProduct() {
      this.$store.commit(
        "bnplInStoreApplication/removeProduct",
        this.productIndex
      );
    },
  },
};
</script>
<style lang="scss">
.trash {
  cursor: pointer;
}

.validator-field {
  margin: 0;
}
</style>
